export default __webpack_public_path__ + "static/media/company.f1d8e7bc.svg";